import React from 'react';
import {Typeahead} from '../components/typeahead';
import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';

export const toGqlVariables = (obj) => {
    const vars = [];
    const stringValues = ['startsWith']; // can add more keys in future if they have String as values
    Object.entries(obj).forEach(([key, val]) => {
        if (stringValues.includes(key)) {
            vars.push(`${key}: "${val}"`);
        } else {
            vars.push(`${key}: ${val}`);
        }
    });
    const varsBracket = vars.length ? `(${vars.join(', ')})` : '';
    return varsBracket;
};

export const useRecentResults = (search) => {
    const filteredSearch = search.replace(/\\/g, '').replace(/\"/g, '');

    const queryArguments = {
        useHistory: true,
        startsWith: filteredSearch,
        limit: 8
    };

    const GET_SUGGESTIONS = gql`
        query {
            typeAheadSuggestions${toGqlVariables(queryArguments)} {
                gaiaId
                term
    			type
                matchType
    			uuid
            }
        }
    `;
    const {data, loading} = useQuery(GET_SUGGESTIONS);

    return {
        data,
        loading
    };
};

export const selectHistoryfromEGTA = (suggestions) => {
    let results = [];
    for (let i = 0; i < suggestions.length; i++) {
        if (suggestions[i].matchType === 'RECENT_HISTORY') {
            results.push({
                recentlyviewed: true,
                ...suggestions[i]
            });
        }
    }
    return results;
};

export const getRecentlyViewed = (recentResults) => {
    return recentResults.loading || !recentResults.data
        ? []
        : selectHistoryfromEGTA(recentResults.data.typeAheadSuggestions);
};

export const getResults = (
    recentResults,
    resultWithoutHistory,
    resultWithHistory
) => {
    return recentResults.loading ? resultWithoutHistory : resultWithHistory;
};

export const filterSimilarResults = (resultWithoutHistory, historyResults) => {
    let recentResultsGaiaID = [];

    historyResults.forEach((value) => {
        recentResultsGaiaID.push(value.gaiaId);
    });

    let results = resultWithoutHistory.filter(
        (item) => !recentResultsGaiaID.includes(item.gaiaId)
    );

    const finalfilteredResult = historyResults.concat(results);
    return finalfilteredResult;
};

export const getResultsWithHistory = (results, recentlyViewedResults) => {
    return results
        ? filterSimilarResults(results, recentlyViewedResults)
        : recentlyViewedResults;
};

const FunctionalContainer = (props) => {
    const defaultResults = {loading: true, data: []};
    const recentResults = props.search
        ? useRecentResults(props.search)
        : defaultResults;

    let newProps = {...props};

    const resultWithoutHistory = props.results;

    const resultWithHistory = getResultsWithHistory(
        resultWithoutHistory,
        getRecentlyViewed(recentResults)
    );

    newProps.results = getResults(
        recentResults,
        resultWithoutHistory,
        resultWithHistory
    );
    return <Typeahead {...newProps} />;
};

export default FunctionalContainer;
